import { Box, Typography, Grid, Paper } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import checkIcon from "../../../../img/check-icon-green.png";

export default function ReturnItemsConfirmation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnOrderNumber = searchParams.get("rmOrderNumber") ?? "";

  return (
    <Box>
      <div id="ph-title" className="text-center page-title">
        <h1>RM #{returnOrderNumber}</h1>
      </div>
      <Box sx={{ p: 2, marginTop: "-30px" }}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 3 }}
        >
          <Typography
            onClick={() => navigate("/order/history")}
            sx={{
              color: "#54afe2",
              fontSize: "14px",
              fontFamily: 'normal 14px "Montserrat", Verdana, sans-serif',
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            {"< Back to All Orders"}
          </Typography>
        </Grid>

        <Box sx={{ mt: 4 }}>
          <Paper
            elevation={6}
            sx={{
              textAlign: "center",
              p: 4,
              maxWidth: "600px",
              mx: "auto",
              borderRadius: 2,
            }}
          >
            <Typography
              variant="h4"
              fontWeight={600}
              sx={{ mb: 2 }}
              color={"#494440"}
              fontFamily={'"Montserrat",Verdana,sans-serif'}
            >
              Confirmation of Return Request
            </Typography>

            <Typography
              variant="h6"
              sx={{ mb: 3 }}
              color={"#494440"}
              fontFamily={'"Montserrat",Verdana,sans-serif'}
            >
              Your return request has been submitted.
            </Typography>

            <Box component="img" src={checkIcon} height={90} sx={{ mb: 3 }} />

            <Typography
              fontSize={"14px"}
              color={"#494440"}
              fontFamily={'"Montserrat",Verdana,sans-serif'}
            >
              Your return number is: #{returnOrderNumber}
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
